export abstract class NapaForm<P = unknown> {
  abstract get payload(): P;

  get storePayload() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.payload as any;
  }

  abstract get isValid(): boolean;

  abstract markAllAsTouched(): void;
}

// Should be implemented (used as a contract), not extended for inheritance
export abstract class NapaFormController<P = unknown, V = unknown> {
  abstract patchForm(value: V): void;

  abstract markAllAsTouched(): void;

  abstract get isValid(): boolean;

  abstract get payload(): P;
}
